/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import clockFill from '@iconify/icons-eva/clock-fill';
import moment from 'moment';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';
import 'moment/locale/en-gb';

// material
import {
  Box,
  Avatar,
  Typography,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  // IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
// components
import RenderContent from './RenderContent';
import useLang from '../../hooks/useLang';
// api
import { updateMsgList } from '../../api/user';

const momentLang = {
  zh: 'zh-hk',
  en: 'en',
  cn: 'zh-cn',
};

export default function NotificationItem({
  notification,
  onHandleClick,
  refreshData,
}) {
  const { title } = RenderContent({ notification });
  const { language } = useLang();
  const { t } = useTranslation('main');
  const { enqueueSnackbar } = useSnackbar();
  // 切换moment语言
  moment.locale(momentLang[language]);

  const [isLoading, setIsLoading] = useState(false);
  const handleDeleteMsg = (event) => {
    // 取消事件冒泡
    event.stopPropagation();
    setIsLoading(true);
    updateMsgList({ id: notification.id, action: 'archive' })
      .then(() => {
        enqueueSnackbar(t('msg_sccuss'), { variant: 'success' });
        // 刷新列表数据
        refreshData();
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <ListItemButton
      to="#"
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        background: notification?.is_read === 'N' ? '#EDEFF1' : '#FFF',
      }}
      onClick={onHandleClick}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: 'background.neutral' }}>
          <img src="/static/icons/ic_notification_mail.svg" alt="" />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled',
            }}
          >
            <Box
              component={Icon}
              icon={clockFill}
              sx={{ mr: 0.5, width: 16, height: 16 }}
            />
            {moment(notification.create_time).fromNow()}
          </Typography>
        }
      />
      {/* <LoadingButton onClick={handleDeleteMsg} loading={isLoading}>
        <CloseIcon />
      </LoadingButton> */}
    </ListItemButton>
  );
}
